import form from './form.js';
import index from './index';
import { Router } from '@/legacy/Router';

Router.get('payment-schedule-templates', index);
Router.get('payment-schedule-templates/new', form);
Router.get('payment-schedule-templates/([a-zA-Z]+)', form);
